import { ListContainerComponent } from './list-container.component';
import {
  ListVariantHubComponent,
  ListVariantStepByStepComponent,
  ListVariantMinimalComponent,
} from './variants';

const listVariants = [
  ListVariantHubComponent,
  ListVariantStepByStepComponent,
  ListVariantMinimalComponent,
];

export const listComponents = [...listVariants, ListContainerComponent];
